import { gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React, { Fragment } from 'react';
import Button from '../../button/Button';
import Divider from '../../divider/Divider';
import { useTheme } from '../../theme-context';
import Toggle from '../../toggle/Toggle';
import './print-dialog-style.scss';

interface IPrintDialog {
    printAction: () => void;
    printOptions: {
        id: string;
        value: boolean;
        label: string;
    }[];
    onChange: (id: string, value: string) => void;
}

const PrintDialog = ({
    printAction,
    onChange,
    printOptions,
}: IPrintDialog): React.ReactElement => {
    const { getFont } = useTheme();

    return (
        <div className="print-dialog">
            <div
                className={css({
                    background: 'white',
                    letterSpacing: '0',
                    padding: '16px 0px 0px 16px',
                    borderRadius: '5px',
                })}
            >
                <p
                    className={css({
                        fontFamily: getFont('desktop/body/medium/bold')
                            .fontFamily,
                        fontWeight: getFont('desktop/body/medium/bold')
                            .fontWeight,
                        fontSize: getFont('desktop/body/medium/bold').fontSize,
                        lineHeight: `${
                            getFont('desktop/body/medium').lineHeightPx
                        }px`,
                    })}
                >
                    {gettext('Print settings')}
                </p>
                <div
                    className={css({
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, auto)',
                        padding: '16px 0px 0px',
                        justifyItems: 'end',
                    })}
                >
                    {printOptions.map((printOption) => {
                        const { id, value, label } = printOption;

                        return (
                            <Fragment key={id}>
                                <div
                                    className={css({ justifySelf: 'baseline' })}
                                >
                                    <p
                                        className={css({
                                            fontFamily: getFont(
                                                'desktop/body/medium',
                                            ).fontFamily,
                                            fontWeight: getFont(
                                                'desktop/body/medium',
                                            ).fontWeight,
                                            fontSize: getFont(
                                                'desktop/body/medium',
                                            ).fontSize,
                                            lineHeight: `${
                                                getFont('desktop/body/medium')
                                                    .lineHeightPx
                                            }px`,
                                            marginBottom: '16px',
                                        })}
                                    >
                                        {label}
                                    </p>
                                </div>
                                <div
                                    className="print-dialog-toggle"
                                    data-testid={id}
                                >
                                    <Toggle
                                        data-testid={`${id}-toggle`}
                                        id={id}
                                        value={value.toString()}
                                        checked={value}
                                        onChange={(newValue) => {
                                            onChange(id, newValue);
                                        }}
                                    />
                                </div>
                            </Fragment>
                        );
                    })}
                </div>
            </div>
            <div
                className={css({
                    position: 'absolute',
                    bottom: '0',
                    width: '100%',
                })}
            >
                <Divider />
                <div
                    className={css({
                        float: 'right',
                        margin: '16px 18px',
                    })}
                    data-testid="confirm-print-button"
                >
                    <Button style="fill" onClick={printAction}>
                        {gettext('Print')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default PrintDialog;
